export const topBikeKey = 'topBike';
export const topCarKey = 'topCar';
export const topCommercialKey = 'topCommercial';
export const topDealerKey = 'topDealer';
export const topServiceKey = 'topService';
export const topCompanyKey = 'topCompany';
export const topRentKey = 'topRent';
export const topPlacementKey = 'topPlacement';
export const topPartsKey = 'topParts';
